import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=c09a1a82&"
var script = {}
import style0 from "./IconClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c09a1a82')) {
      api.createRecord('c09a1a82', component.options)
    } else {
      api.reload('c09a1a82', component.options)
    }
    module.hot.accept("./IconClose.vue?vue&type=template&id=c09a1a82&", function () {
      api.rerender('c09a1a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconClose.vue"
export default component.exports